<table mat-table [dataSource]="sortedConnectors()" class="connectors">
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td
      mat-cell
      *matCellDef="let connector"
      [class.highlight]="connector.pricePolicyId === selectedPricePolicyId && !connector.hasRestricedAccess">
      @if ((connector.firestoreConnectorInfo?.getValue()?.connectorStatus ?? connectorStatusEnum.Unknown) === connectorStatusEnum.Unknown) {
        <svg class="icon-20" [matTooltip]="'Status: Ukendt'"><use href="assets/images/ok-icons-sprite.svg#state-unknown"></use></svg>
      }
      @if (connector.firestoreConnectorInfo?.getValue()?.connectorStatus === connectorStatusEnum.Available) {
        <svg class="icon-20" [matTooltip]="'Status: Tilgængelig'"><use href="assets/images/ok-icons-sprite.svg#state-available"></use></svg>
      }
      @if (connector.firestoreConnectorInfo?.getValue()?.connectorStatus === connectorStatusEnum.Unavailable) {
        <svg class="icon-20" [matTooltip]="'Status: Ikke tilgængelig'">
          <use href="assets/images/ok-icons-sprite.svg#state-unavailable"></use>
        </svg>
      }
      @if (connector.firestoreConnectorInfo?.getValue()?.connectorStatus === connectorStatusEnum.Charging) {
        <svg class="icon-20" [matTooltip]="'Status: Oplader'"><use href="assets/images/ok-icons-sprite.svg#state-charging"></use></svg>
      }
      @if (connector.firestoreConnectorInfo?.getValue()?.connectorStatus === connectorStatusEnum.Faulted) {
        <svg class="icon-20" [matTooltip]="'Status: Ude af drift'"><use href="assets/images/ok-icons-sprite.svg#state-faulted"></use></svg>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="stationNumber">
    <th mat-header-cell *matHeaderCellDef>Ladepunkt</th>
    <td
      mat-cell
      *matCellDef="let connector"
      [class.highlight]="connector.pricePolicyId === selectedPricePolicyId && !connector.hasRestricedAccess">
      {{ connector.stationNumber }}
    </td>
  </ng-container>
  <ng-container matColumnDef="csid">
    <th mat-header-cell *matHeaderCellDef>CSID</th>
    <td
      mat-cell
      *matCellDef="let connector"
      [class.highlight]="connector.pricePolicyId === selectedPricePolicyId && !connector.hasRestricedAccess">
      @if (connector.stationIdentifier) {
        <a class="blue" [href]="getCsManagementChargingStationsUrl(connector.stationIdentifier)" target="_blank" rel="noopener noreferrer">
          {{ connector.stationIdentifier }}
        </a>
      } @else {
        -
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="maxPower">
    <th mat-header-cell *matHeaderCellDef>Effekt op til</th>
    <td
      mat-cell
      *matCellDef="let connector"
      [class.highlight]="connector.pricePolicyId === selectedPricePolicyId && !connector.hasRestricedAccess">
      @if (connector.power || connector.power === 0) {
        {{ connector.power }} kW
      } @else {
        -
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="pricePerKwh">
    <th mat-header-cell *matHeaderCellDef>
      <span class="price-header">
        Forbrugerpris
        <span class="price-header-wrap">
          <span class="price-header__sub-title">Inkl. moms</span>
          <span
            class="info-icon"
            matTooltip="Forbrugerprisen er den samlede pris inkl. moms og består af strømsats, OK-tillæg og kundetillæg. Ved en dynamisk prispolitik er strømsatsen hentet ud fra lokationens adresse"
            matTooltipPosition="below">
            <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
          </span>
        </span>
      </span>
    </th>
    <td
      mat-cell
      *matCellDef="let connector"
      [class.highlight]="connector.pricePolicyId === selectedPricePolicyId && !connector.hasRestricedAccess">
      <span class="consumer-price">
        {{ connector.consumerPriceInclVat | number: '1.2-2' }} kr.
        @if (connector.priceType === PriceType.Dynamic) {
          <svg (click)="openDynamicPriceChartDialog(connector)" class="icon-20 price-chart-icon">
            <use href="assets/images/ok-icons-sprite.svg#chart-line-s"></use>
          </svg>
        }
      </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="pricePolicyName">
    <th mat-header-cell *matHeaderCellDef>Prispolitik</th>
    <td
      mat-cell
      *matCellDef="let connector"
      [class.highlight]="connector.pricePolicyId === selectedPricePolicyId && !connector.hasRestricedAccess">
      @if (connector.pricePolicyId) {
        <a class="blue" [routerLink]="['/price-policies']" [queryParams]="{ pricePolicyId: connector.pricePolicyId }">
          {{ connector.pricePolicyName }}
        </a>
      } @else {
        {{ connector.pricePolicyName ?? '-' }}
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="accessGroups">
    <th mat-header-cell *matHeaderCellDef>Adgangsgrupper</th>
    <td
      mat-cell
      *matCellDef="let connector"
      [class.highlight]="connector.pricePolicyId === selectedPricePolicyId && !connector.hasRestricedAccess">
      <span class="icon-with-text">
        @if (connector.accessGroups.length > 0) {
          <a
            class="blue"
            [routerLink]="['/access-groups']"
            [queryParams]="{
              connectorIdentifier: connector.identifier,
              selectedConnectorDescription:
                connector.stationIdentifier + (connector.stationNumber ? ' - ladepunkt ' + connector.stationNumber : ''),
            }">
            {{ connector.accessGroups.length }}&nbsp;gruppe{{ connector.accessGroups.length === 1 ? '' : 'r' }}
          </a>
        }
        @if (connector.accessGroups.length === 0) {
          <span>{{ connector.accessGroups.length }}&nbsp;gruppe{{ connector.accessGroups.length === 1 ? '' : 'r' }}</span>
        }
        @if (connector.accessGroups.length > 0) {
          <svg class="icon-24 access-group-info-icon" [matTooltip]="connector.accessGroupsNames">
            <use href="assets/images/ok-icons-sprite.svg#info-s"></use>
          </svg>
        }
      </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="terminals">
    <th mat-header-cell *matHeaderCellDef>Betalingsterminaler</th>
    <td
      mat-cell
      *matCellDef="let connector"
      [class.highlight]="connector.pricePolicyId === selectedPricePolicyId && !connector.hasRestricedAccess">
      @if (connector.terminals && connector.terminals.length > 0) {
        <span class="icon-with-text terminal-container">
          @for (terminal of connector.terminals; track terminal; let last = $last) {
            @if (terminal.type === 'Payter') {
              <a
                class="blue"
                [class.margin--bottom-s]="!last"
                [routerLink]="['/payment-terminals/payter']"
                [admRequiresFeatureRole]="roles['payter-payment-terminal.read']"
                [queryParams]="{
                  serialNumber: terminal.serialNumber,
                  filterName: 'ptsFilterModel',
                }">
                {{ terminal.serialNumber }}
              </a>
            } @else {
              Ukendt
            }
          }
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="image">
    <th mat-header-cell *matHeaderCellDef>Billede</th>
    <td
      mat-cell
      *matCellDef="let connector"
      class="connector-thumbnail"
      [class.highlight]="connector.pricePolicyId === selectedPricePolicyId && !connector.hasRestricedAccess">
      @if (!connector.isThumbnailHidden) {
        <button
          type="button"
          (click)="showImage(connector)"
          class="btn-icon"
          [admRequiresFeatureRole]="roles['charging-station-location.read']">
          <img [src]="connector.connectorThumbnail" (error)="connector.isThumbnailHidden = true" />
        </button>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="edit">
    <th mat-header-cell *matHeaderCellDef class="col align-right"></th>
    <td
      mat-cell
      *matCellDef="let connector"
      class="row align-right"
      [class.highlight]="connector.pricePolicyId === selectedPricePolicyId && !connector.hasRestricedAccess">
      <button
        mat-icon-button
        [matMenuTriggerFor]="contextMenu"
        aria-label="Handlinger"
        [admRequiresFeatureRole]="roles['connector-picture.write'] + ',' + roles['charging-station-location-price-policy.write']">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #contextMenu="matMenu">
        <button mat-menu-item (click)="openEditImage(connector)" [admRequiresFeatureRole]="roles['connector-picture.write']">
          <mat-icon svgIcon="image"></mat-icon>
          <span>Tilføj/rediger billede</span>
        </button>
        <button
          mat-menu-item
          (click)="openEditPricePolicy(connector)"
          [admRequiresFeatureRole]="roles['charging-station-location-price-policy.write']">
          <mat-icon svgIcon="sell_outlined"></mat-icon>
          <span>Rediger prispolitik for ladepunkt</span>
        </button>
        @if (connector.firestoreConnectorInfo?.getValue()) {
          <div class="table-container" [admRequiresFeatureRole]="roles['price-policy.read']">
            <table class="table table-container__table">
              <thead>
                <tr>
                  <th>Firestore data</th>
                  <th style="text-align: right; font-size: 0.6rem; font-weight: normal">
                    {{ connector.firestoreConnectorInfo?.getValue()?.firestoreIdentifier }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Status</td>
                  <td class="align-right">
                    @if (
                      (connector.firestoreConnectorInfo?.getValue()?.connectorStatus ?? connectorStatusEnum.Unknown) ===
                      connectorStatusEnum.Unknown
                    ) {
                      <div class="coin coin--grey"></div>
                      Ukendt status
                    }
                    @if (connector.firestoreConnectorInfo?.getValue()?.connectorStatus === connectorStatusEnum.Available) {
                      <div class="coin coin--green"></div>
                      Tilgængelig
                    }
                    @if (connector.firestoreConnectorInfo?.getValue()?.connectorStatus === connectorStatusEnum.Unavailable) {
                      <div class="coin coin--yellow"></div>
                      Ikke tilgængelig
                    }
                    @if (connector.firestoreConnectorInfo?.getValue()?.connectorStatus === connectorStatusEnum.Charging) {
                      <div class="coin coin--blue"></div>
                      I brug
                    }
                    @if (connector.firestoreConnectorInfo?.getValue()?.connectorStatus === connectorStatusEnum.Faulted) {
                      <div class="coin coin--red"></div>
                      Ude af drift
                    }
                  </td>
                </tr>
                @if (connector.firestoreConnectorInfo?.getValue()?.pricePerKwhInOere) {
                  <tr>
                    <td>Pris (inkl. moms):</td>
                    <td class="align-right">
                      {{ connector.firestoreConnectorInfo?.getValue()?.pricePerKwhInOere / 100 | number: '1.2-2' }} kr.
                    </td>
                  </tr>
                }
                <tr>
                  <td>Begrænset adgang</td>
                  <td class="align-right">
                    @if (connector.firestoreConnectorInfo?.getValue()?.hasLimitedAccess) {
                      Ja
                    }
                    @if (!connector.firestoreConnectorInfo?.getValue()?.hasLimitedAccess) {
                      Nej
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        }
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>

  <tr
    [matBadge]="'!'"
    [matBadgePosition]="'before'"
    [matBadgeHidden]="!connector.showDangerBadge"
    mat-row
    *matRowDef="let connector; columns: displayColumns"
    [matTooltip]="connector.dangerBadgeMessage"
    [matTooltipDisabled]="!connector.showDangerBadge"
    [class.notification--error]="connector.showDangerBadge"></tr>
</table>
